export default __webpack_public_path__ + "static/media/bernay17.387acb61.jpg";